import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiGet, apiPost } from "../../api/apiclient";
import { DOWNLOAD_FILE, DOWNLOAD_FILE_RESULT } from "../../api/endpoints";

// Async thunk for logging in
export const pdfDetails = createAsyncThunk(
  "/api/pdfDetails/",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiGet(`${DOWNLOAD_FILE_RESULT}${id}/`);
      if (response?.data.status === "success") {
        return response?.data;
      } else {
        return rejectWithValue(
          response.data.message || "Unexpected error occurred."
        );
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message || "Network error occurred.");
    }
  }
);

// Async thunk for logging in
export const pdfDownload = createAsyncThunk(
  "/api/pdfDownloads/",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiGet(`${DOWNLOAD_FILE}${id}/`);
      if (response?.data) {
        return response?.data;
      } else {
        return rejectWithValue(
          response.data.message || "Unexpected error occurred."
        );
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message || "Network error occurred.");
    }
  }
);



const PdfDataSlice = createSlice({
  name: "ai_agents",
  initialState: {
    pdfDataLoading: false,
    pdfDataError: {},
    pdfData: [],

    pdfFileLoading: false,
    pdfFileError: {},
    pdfFile: {}

  },
  extraReducers: (builder) => {
      builder
      .addCase(pdfDetails.pending, (state) => {
        state.pdfDataLoading = true;
        state.pdfDataError = null;
      })
      .addCase(pdfDetails.fulfilled, (state, action) => {
        state.pdfDataLoading = false;
        state.pdfData = action.payload
      })
      .addCase(pdfDetails.rejected, (state, action) => {
        state.pdfDataLoading = false;
        state.pdfDataError = action.payload
      })
      .addCase(pdfDownload.pending, (state) => {
        state.pdfFileLoading = true;
        state.pdfFileError = null;
      })
      .addCase(pdfDownload.fulfilled, (state, action) => {
        state.pdfFileLoading = false;
        state.pdfFile = action.payload
      })
      .addCase(pdfDownload.rejected, (state, action) => {
        state.pdfFileLoading = false;
        state.pdfFileError = action.payload
      });
  },
});

export default PdfDataSlice.reducer;
